import React from 'react';
import { bool, func, array } from 'prop-types';
import T from 'i18n-react';

import DropDown from './components/DropDown';
import { StatusColorIndicatorOption } from '@adsk/bim360-matrix-react-components';
import { statusColorMapping, RFIS_SORTED_STATUSES } from '../../../constants/status-types';

const StatusDropDown = ({ disabled, selectedStatuses, onChange }) => {
  const statusOptions = RFIS_SORTED_STATUSES.map(status => ({
    label: T.translate(`status.${status}`),
    value: status,
  }));
  const selectedStatusFilters = statusOptions.filter(status =>
    selectedStatuses.includes(status.value)
  );
  return (
    <DropDown
      label={T.translate("new.status")}
      selectedOptions={selectedStatusFilters}
      options={statusOptions}
      disabled={disabled}
      optionRenderer={(value, label) => (
        <StatusColorIndicatorOption
          disabled={disabled}
          statusColor={statusColorMapping[value]}
          label={label}
        />
      )}
      onChange={onChange}
      placeholder={T.translate("filter.status")}
    />
  );
};
StatusDropDown.propTypes = {
  disabled: bool,
  selectedStatuses: array.isRequired,
  onChange: func.isRequired,
};


export default StatusDropDown;
